<template>
    <div id="loading-indicator" v-if="loading">
        <div class="fas fa-circle-notch fa-spin fa-4x spinner"></div>
    </div>
</template>
<script>


export default {
    name: 'loading',
    props : {
        loading : {
            type : Boolean,
            default : false
        }
    },
    // computed : {
    //     parentLoading : function () {
    //         if (typeof this.$parent.loading !== 'undefined') {
    //             return this.$parent.loading;
    //         }
    //         return this.loading;
    //     }
    // },
    // watch : {
    //     parentLoading : function () {
    //         console.log('PARENT LOADING IS', this.parentLoading);
    //         if (typeof this.$parent.loading !== 'undefined') {
    //             console.log('PARENT LOADING IS DEFINED');
    //             if (this.loading !== this.parentLoading) {
    //                 console.log('reactive loading is broken, resetting');
    //                 this.loading = this.parentLoading;
    //             }
    //         }
    //     },
    //     loading : function (val) {
    //         console.log('LOADING IS', this.loading);
    //     }
    // }
}
</script>